import { Stack, Subheader3, Switch } from '@collaborate-health/uikit'
import { ContentSharingModelType } from '@tabeeb/contracts/main-api/swagger-main-api'
import { useSelector } from '@tabeeb/store'
import { getIsCheckInRecordsEnabled } from '@tabeeb/modules/appConfigState/selectors'
import { CopyCheckInsSwitchProps } from './CopyCheckInsSwitch.types'

const CopyCheckInsSwitch: React.FC<CopyCheckInsSwitchProps> = ({
  contentSharingType,
  shouldCopyCheckIns,
  toggleShouldCopyCheckIns,
}) => {
  const featureEnabled = useSelector(getIsCheckInRecordsEnabled)

  if (!featureEnabled || contentSharingType !== ContentSharingModelType.MergeForReview) {
    return null
  }

  return (
    <Stack direction='row' alignItems='center' spacing={1} mb={2}>
      <Subheader3>Include check-in records</Subheader3>
      <Switch checked={shouldCopyCheckIns} onClick={() => toggleShouldCopyCheckIns(!shouldCopyCheckIns)} />
    </Stack>
  )
}

export default CopyCheckInsSwitch

